import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useLocation, useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import { getEntries } from '../utils/api';

function Test(props) {
    const { category: categoryParam } = useParams();
    const { pageScroll } = props;
    const [on, setOn] = useState(false);
    const [entries, setEntries] = useState([]);
    const [activeYear, setActiveYear] = useState('');
    const [lightbox, setLightbox] = useState(null);
    const location = useLocation();
    const locationNum = location.pathname.split("/");
    // /photo/*, /art/* → first URL segment; /test/:category → the category param
    const category = locationNum[1] === 'test' ? (categoryParam || 'photo') : locationNum[1];

    const h3Refs = useRef([]);
    const sectionRefs = useRef([]);

    useEffect(() => {
        if (category !== props.pageN?.page) props.pageF?.(category);
        const t = setTimeout(() => setOn(true), 100);
        return () => clearTimeout(t);
    });

    useEffect(() => {
        getEntries(category || 'photo')
            .then(data => {
                setEntries(data);
                if (data.length > 0) setActiveYear(data[0].year);
            })
            .catch(console.error);
    }, [category]);

    useEffect(() => {
        const threshold = 160;
        let active = null;
        for (const h3 of h3Refs.current.filter(Boolean)) {
            if (h3.getBoundingClientRect().top <= threshold) {
                const span = h3.querySelector('span');
                if (span) active = span.textContent.trim();
            }
        }
        if (active) setActiveYear(active);
    }, [pageScroll]);

    useEffect(() => {
        if (!lightbox) return;
        const onKey = (e) => { if (e.key === 'Escape') setLightbox(null); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [lightbox]);

    const scrollToSection = (index) => {
        sectionRefs.current[index]?.scrollIntoView({ behavior: 'smooth' });
    };

    const renderBlock = (block, key) => {
        if (block.type === 'paragraph') {
            const match = block.text.match(/^(\S+)([\s\S]*)$/);
            const firstWord = match ? match[1] : block.text;
            const rest = match ? match[2] : '';
            const lines = rest.split('\n');
            return (
                <p key={key}>
                    <span>{firstWord}</span>
                    {lines.map((line, i) => (
                        <React.Fragment key={i}>
                            {line}
                            {i < lines.length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </p>
            );
        }
        if (block.type === 'figure') {
            const src = process.env.PUBLIC_URL + block.src;
            return (
                <figure key={key}>
                    <img
                        src={src}
                        alt=""
                        style={{ cursor: 'zoom-in' }}
                        onClick={() => setLightbox(src)}
                    />
                    <figcaption dangerouslySetInnerHTML={{ __html: block.caption }} />
                </figure>
            );
        }
        if (block.type === 'imgBox') {
            return (
                <div key={key} className="imgBox">
                    <Swiper
                        slidesPerView="auto"
                        spaceBetween={0}
                        pagination={{ clickable: true }}
                        modules={[Pagination]}
                        className="photo_2023"
                    >
                        {block.images.map((img) => {
                            const src = process.env.PUBLIC_URL + img.src;
                            return (
                                <SwiperSlide key={img.id} className={img.className || ''}>
                                    <img
                                        src={src}
                                        alt=""
                                        style={{ cursor: 'zoom-in' }}
                                        onClick={() => setLightbox(src)}
                                    />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            );
        }
        return null;
    };

    const label = category === 'art' ? 'Art' : 'Photo';

    return (
        <div className={on ? "conBox on" : "conBox"}>
            <div className="topBg"></div>
            <div className="conTopWave">
                <div className="conTopWaveIn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6000" height="240" viewBox="0 0 6000 240" preserveAspectRatio="xMidYMid slice">
                        <pattern id="wave" width=".25" height="1.1" patternContentUnits="objectBoundingBox">
                            <path fill="#1A2C2D" d="M0.25,1H0c0,0,0-0.659,0-0.916c0.083-0.303,0.158,0.334,0.25,0C0.25,0.327,0.25,1,0.25,1z"></path>
                        </pattern>
                        <rect width="6000px" height="140"></rect>
                    </svg>
                </div>
                <div className="photoLeftBox">
                    <ul>
                        {entries.map((entry, i) => (
                            <li key={entry.id} className={activeYear === entry.year ? 'on' : ''}>
                                <a href="#!" onClick={(e) => { e.preventDefault(); scrollToSection(i); }}>
                                    {entry.year}<span>{entry.title}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="pageNameBox">
                <div className="pageNameBoxIn">
                    <h2>PORTFOLIO</h2>
                    <p>{label}</p>
                </div>
            </div>
            <div className="photoConBoxIn">
                <div className="photoRightBox">
                    <ul>
                        {entries.length === 0 ? (
                            <li style={{ padding: '60px 0', textAlign: 'center', opacity: 0.5 }}>
                                등록된 콘텐츠가 없습니다. <a href="/admin" style={{ color: 'inherit' }}>관리자</a>에서 추가해주세요.
                            </li>
                        ) : entries.map((entry, i) => (
                            <li key={entry.id} ref={el => sectionRefs.current[i] = el}>
                                <h3 ref={el => h3Refs.current[i] = el}>
                                    <span>{entry.year}</span> {entry.title}
                                </h3>
                                {entry.blocks.map((block, j) => renderBlock(block, block.id || j))}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {lightbox && ReactDOM.createPortal(
                <div
                    onClick={() => setLightbox(null)}
                    style={{
                        position: 'fixed',
                        top: 0, left: 0, right: 0, bottom: 0,
                        background: 'rgba(0,0,0,0.88)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        cursor: 'zoom-out',
                    }}
                >
                    <img
                        src={lightbox}
                        alt=""
                        style={{
                            maxWidth: '840px',
                            width: '95vw',
                            maxHeight: '92vh',
                            objectFit: 'contain',
                            display: 'block',
                            cursor: 'zoom-out',
                        }}
                    />
                </div>,
                document.body
            )}
        </div>
    );
}

export default Test;
